import React, { createContext, useRef, useState } from "react";
import Popover, { AnchorRect } from "./Popover";
import { useWindowScrollObserver } from "./useWindowScrollObserver";

export const PopoverContext = createContext<{
    showPopover: (
        anchor: AnchorRect,
        overlay: React.ReactNode,
        mousePos?: { x: number; y: number },
        placement?: Placement
    ) => void;
    hidePopover: () => void;
}>({
    showPopover: () => { },
    hidePopover: () => { },
});

type Placement = "top" | "bottom" | "left" | "right" | "auto";

export const PopoverProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const popRef = useRef<HTMLDivElement | null>(null);
    const [open, setOpen] = useState(false);
    const [anchor, setAnchor] = useState<AnchorRect>(null);
    const [overlay, setOverlay] = useState<React.ReactNode>(null);
    const [placement, setPlacement] = useState<Placement>('auto');
    const [mousePos, setMousePos] = useState<{ x: number; y: number } | null>(null);

    const isScrolling = useWindowScrollObserver();
    const showPopover = (
        anchorRect: AnchorRect,
        overlayNode: React.ReactNode,
        mPos?: { x: number; y: number },
        placement: Placement = 'auto'
    ) => {
        if (!overlayNode || isScrolling) return

        setAnchor(anchorRect);
        setOverlay(overlayNode);
        setOpen(true);
        setPlacement(placement);
        setMousePos(mPos || null);
    };


    const hidePopover = () => setOpen(false);

    return (
        <PopoverContext.Provider value={{ showPopover, hidePopover }}>
            {children}
            <Popover
                ref={popRef}
                anchorRect={anchor}
                open={open}
                onClose={() => setOpen(false)}
                placement={placement}
                mousePos={mousePos}
            >
                {overlay}
            </Popover>
        </PopoverContext.Provider>
    );
};
